import { render } from "./S176246.vue?vue&type=template&id=e9d851e4"
const script = {}
script.render = render

export default script